import { render, staticRenderFns } from "./FormChiTietAnPham.vue?vue&type=template&id=929c6f8e&scoped=true"
import script from "./FormChiTietAnPham.vue?vue&type=script&lang=js"
export * from "./FormChiTietAnPham.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "929c6f8e",
  null
  
)

export default component.exports